import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

export interface AddPointCapabilities {
    /** True if user is in a manager role (SV, SVM, etc.). */
    isManager: boolean;
    /** True if user can fetch team routes and team members (non-KAM). */
    canFetchTeamRoutes: boolean;
}

export const getAddPointCapabilities = (
    role: UserRole,
): AddPointCapabilities => {
    const isManager = isManagerRole(role);
    const isKam = role === UserRole.Kam;

    return {
        isManager,
        canFetchTeamRoutes: !isKam,
    };
};
